import { Parsing } from "./parsing";
import { cr } from "fire-wind-water";

class SkClass extends Parsing {
  private exp: any;
  private className = "";

  constructor(
    private elem: HTMLElement,
    private attr: string,
    private module: any
  ) {
    super();
    this.exp = Parsing.expression(attr);
    this.className = this.elem.className + " ";
    this.update();
  }

  private update(): void {
    const value = this.exp.call(this.module);
    if (cr.isString(value)) {
      this.elem.className = this.className + value;
    } else if (cr.isPlainObject(value)) {
      const str: string[] = [];
      cr.each(value, (d, k) => {
        if (d) {
          str.push(k);
        }
      });
      this.elem.className = this.elem.className + str.join(" ");
    }
  }
}

export { SkClass };
